/**
 * This helper is extracted from this post https://stackoverflow.com/questions/133925/javascript-post-request-like-a-form-submit#comment54049883_133997
 * sends a request to the specified url from a form. this will change the window location.
 * @param {string} path the path to send the post request to
 * @param {object} params the parameters to add to the url
 * @param {string} [method=post] the method to use on the form
 */

export const post = (path, params, method = "POST") => {
  const form = document.createElement("form")
  form.method = method
  form.action = path

  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const hiddenField = document.createElement("input")
      hiddenField.type = "hidden"
      hiddenField.name = key
      hiddenField.value = params[key]

      form.appendChild(hiddenField)
    }
  }

  document.body.appendChild(form)

  form.submit()
}
